<template>
  <v-dialog v-model="visible" width="40rem" persistent scrollable>
    <v-card v-if="is_loading">
      <v-skeleton-loader type="card, list-item@6" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon
            icon="product"
            class="mr-2"
            :strokewidth="3"
            fill="white"
          />
          <v-toolbar-title class="ml-1">
            Artikal
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items v-if="product.id > 0">
            <v-tooltip left color="#e9c46a" open-on-hover open-delay="150">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="show_delete_options = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <sabira_icon icon="trash" fill="white"></sabira_icon>
                </v-btn>
              </template>
              <span>Obriši artikal</span>
            </v-tooltip>
          </v-toolbar-items>
          <v-dialog
            width="30rem"
            persistent
            scrollable
            v-model="show_delete_options"
          >
            <v-card>
              <v-card-title class="pb-0 mb-0">Brisanje artikla</v-card-title>
              <v-card-text class="pt-0 mt-0">
                <v-list color="transparent">
                  <v-list-item>
                    <v-list-item-content>
                      {{
                        "Želite obrisati artikal sa šifrom " +
                          this.product.sifra +
                          "?"
                      }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
              <v-card-actions class="background">
                <v-btn text @click="show_delete_options = false"
                  >Odustani</v-btn
                >
                <v-spacer></v-spacer>
                <v-btn text @click="delete_product()">Obriši</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <template v-slot:extension>
            <v-tabs
              v-model="active_tab"
              hide-slider
              background-color="background darken"
            >
              <v-tab>Info</v-tab>
              <v-tab>Cijena</v-tab>
              <v-tab>Roba</v-tab>
            </v-tabs>
          </template>
        </v-toolbar>
        <v-card-text class="pa-0 ma-0" style="height: 30rem;">
          <div class="master_grid">
            <div>
              <v-tabs-items v-model="active_tab">
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <v-select
                          v-model="product.article_type"
                          outlined
                          label="Vrsta artikla"
                          :items="article_types"
                        ></v-select>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 mb-0 pt-1 pb-0">
                        <v-text-field
                          v-model="product.sifra"
                          outlined
                          label="Šifra artikla"
                          required
                          maxlength="45"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 mb-0 pt-1 pb-0">
                        <v-text-field
                          v-model="product.naziv"
                          outlined
                          label="Naziv artikla"
                          required
                          maxlength="255"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 mb-0 pt-1 pb-0">
                        <v-textarea
                          v-model="product.opis"
                          outlined
                          clearable
                          auto-grow
                          label="Opis artikla"
                          maxlength="1000"
                          counter
                        ></v-textarea>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="mb-0 pb-0">
                        <v-text-field
                          v-model.number="product.purchase_production_price"
                          type="number"
                          outlined
                          label="Nabavna cijena artikla (usluge ili roba koju nabavljate od drugih)"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 mb-0 pt-1 pb-0">
                        <v-text-field
                          v-model.number="product.vpc"
                          type="number"
                          outlined
                          label="Osnovna cijena artikla (bez PDV-a)"
                          hint="Maksimalno 4 decimale"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item
                      v-if="
                        product.purchase_production_price != null &&
                          product.purchase_production_price > 0 &&
                          product.vpc != null &&
                          product.purchase_production_price < product.vpc
                      "
                      style="width: 50%;"
                    >
                      <v-list-item-content class="mt-0 mb-6 pt-0 pb-0">
                        <v-row>
                          <v-col>
                            <v-chip
                              style="background-color:transparent!important;"
                              class="pt-6 pb-6"
                              color="primary"
                              label
                              outlined
                              v-model="price_margin"
                              >{{
                                "Marža" +
                                  " " +
                                  this.$n(parseFloat(price_margin).toFixed(2)) +
                                  "%"
                              }}</v-chip
                            >
                          </v-col>
                          <v-col>
                            <v-chip
                              class="pt-6 pb-6"
                              color="primary"
                              label
                              outlined
                              v-model="price_difference"
                              >{{
                                "RUC" +
                                  " " +
                                  this.$n(
                                    parseFloat(price_difference).toFixed(2)
                                  ) +
                                  " " +
                                  "KM"
                              }}</v-chip
                            >
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 pt-1">
                        <v-select
                          v-model.number="product.pdv_postotak"
                          outlined
                          :items="items"
                          label="PDV postotak"
                          placeholder="Izaberite postotak PDV-a"
                          hide-details
                        ></v-select>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="mt-0 pt-0 mb-0 pb-0">
                      <v-switch
                        class="mt-0 pt-0 mb-0 pb-0"
                        hide-details
                        v-model="product.is_price_list"
                        label="Artikal namijenjen za dalju prodaju. Uvrstiti u cjenovnik."
                      ></v-switch>
                    </v-list-item>
                    <v-list-item class="mt-0 pt-0 mb-0 pb-0">
                      <v-switch
                        class="mt-0 pt-0 mb-0 pb-0"
                        hide-details
                        v-model="product.aktivan"
                        label="Aktivan"
                      ></v-switch>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
                <v-tab-item>
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="mb-2">
                        <webpage_lookup_quantity_type
                          update="wp_event_jm_updated"
                          :selected_id="product.jm_id"
                        ></webpage_lookup_quantity_type>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mb-4">
                        <webpage_lookup_suppliers
                          update="wp_supplier_changed"
                          :selected_id="product.supplier_id"
                        ></webpage_lookup_suppliers>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 mb-0 pt-1 pb-0">
                        <v-text-field
                          outlined
                          v-model="product.serial_number"
                          label="Serijski broj (opciono)"
                          maxlength="100"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 mb-0 pt-1 pb-0">
                        <v-text-field
                          outlined
                          v-model="product.ean_code"
                          label="EAN kod (opciono)"
                          maxlength="100"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content class="mt-0 mb-0 pt-1 pb-0">
                        <v-text-field
                          outlined
                          v-model="product.shelf_life"
                          label="Rok trajanja (opciono)"
                          maxlength="100"
                          counter
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-tab-item>
              </v-tabs-items>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog()">Odustani</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="is_btn_loading"
            text
            depressed
            @click="check_product_code()"
            >Snimi</v-btn
          >
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
export default {
  components: {
    sabira_icon: () => import("@/components/sabira_icon"),
    webpage_lookup_suppliers: () => import("@/components/lookups/suppliers"),
    webpage_lookup_quantity_type: () =>
      import("@/components/lookups/quantity_type"),
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    close: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    items: [
      { text: "0% (firma nije u PDV sistemu)", value: 0 },
      { text: "17%", value: 17 },
    ],
    show_delete_options: false,
    is_loading: true,
    is_btn_loading: false,
    price_margin: 0,
    selected_article_type: null,
    article_types: [
      { text: "Usluga", value: "usluga" },
      { text: "Roba", value: "roba" },
    ],
    active_tab: 0,
    product: {
      id: 0,
      naziv: null,
      sifra: null,
      aktivan: true,
      opis: null,
      pdv_postotak: 0,
      vpc: null,
      article_type: null,
      purchase_production_price: 0,
      serial_number: null,
      ean_code: null,
      shelf_life: null,
      supplier_id: null,
      jm_id: null,
      is_price_list: false,
      is_deleted: 0,
    },
    title: "Unos novog artikla",
    visible: false,
  }),
  computed: {
    margin_calculated() {
      return (
        (this.product.vpc / this.product.purchase_production_price - 1) * 100
      );
    },
    price_difference_calculated() {
      return this.product.vpc - this.product.purchase_production_price;
    },
  },
  mounted() {
    this.visible = true;
    this.setup_event_listeners();
  },
  watch: {
    visible: {
      handler() {
        if (this.id > 0) {
          this.get_product();
        } else {
          this.product = {
            id: 0,
            naziv: null,
            sifra: null,
            aktivan: true,
            opis: null,
            pdv_postotak: 0,
            vpc: 0,
            article_type: null,
            purchase_production_price: 0,
            serial_number: null,
            ean_code: null,
            shelf_life: null,
            supplier_id: null,
            jm_id: null,
            is_price_list: true,
            is_deleted: 0,
          };
          this.is_loading = false;
        }
      },
      immediate: false,
    },
    margin_calculated: {
      handler() {
        this.price_margin = this.margin_calculated;
      },
      immediate: false,
    },
    price_difference_calculated: {
      handler() {
        this.price_difference = this.price_difference_calculated;
      },
      immediate: false,
    },
  },
  destroyed() {
    this.cleanup_event_listeners();
  },
  methods: {
    delete_product() {
      this.$http({
        method: "POST",
        url: "/product/delete",
        data: {
          account_id: this.$store.getters.user.account_id,
          id: this.id,
          is_deleted: 1,
        },
      }).then((resp) => {
        if (resp.status == 200) {
          this.$webpageEventBus.$emit("show_status", {
            type: "success",
            message: "Artikal je obrisan",
            timeout: 2000,
          });
          this.close_dialog();
          this.$webpageEventBus.$emit("reload_data");
        } else {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: resp.data.message,
            timeout: 4000,
          });
        }
      });
    },
    check_product_code() {
      if (
        this.product.id === 0 &&
        this.product.sifra !== null &&
        this.product.sifra !== "" &&
        this.product.sifra.length !== 0
      ) {
        this.$http({
          method: "POST",
          url: "/article/product_code_check",
          data: {
            sifra: this.product.sifra,
            account_id: this.$store.getters.user.account_id,
          },
        }).then((resp) => {
          if (resp.status == 200) {
            const isExists = resp.data[0][0].is_exists;
            if (isExists == 1) {
              this.$webpageEventBus.$emit("show_status", {
                type: "error",
                message:
                  "Upisana šifra artikla već postoji, molimo unesite drugu",
                timeout: 4000,
              });
            } else {
              this.save_product();
            }
          } else {
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: resp.data.message,
              timeout: 4000,
            });
          }
        });
      } else {
        if (
          this.product.id > 0 &&
          this.product.sifra !== null &&
          this.product.sifra !== "" &&
          this.product.sifra.length !== 0
        ) {
          this.$http({
            method: "POST",
            url: "/article/existing_product_code_check",
            data: {
              id: this.product.id,
              sifra: this.product.sifra,
              account_id: this.$store.getters.user.account_id,
            },
          }).then((resp) => {
            if (resp.status == 200) {
              const isExists = resp.data[0][0].is_exists;
              if (isExists == 1) {
                this.$webpageEventBus.$emit("show_status", {
                  type: "error",
                  message:
                    "Upisana šifra artikla već postoji, molimo unesite drugu",
                  timeout: 4000,
                });
              } else {
                this.save_product();
              }
            } else {
              this.$webpageEventBus.$emit("show_status", {
                type: "error",
                message: resp.data.message,
                timeout: 4000,
              });
            }
          });
        } else {
          this.save_product();
        }
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        var has_errors = false;
        if (
          this.product.article_type == null ||
          this.product.article_type.length == 0
        ) {
          has_errors = true;
          reject("Vrsta artikla polje je obavezno");
        }
        if (this.product.sifra == null || this.product.sifra.length == 0) {
          has_errors = true;
          reject("Šifra artikla polje je obavezno");
        }
        if (this.product.naziv == null || this.product.naziv.length == 0) {
          has_errors = true;
          reject("Naziv artikla polje je obavezno");
        }
        if (this.product.opis == null || this.product.opis.length == 0) {
          has_errors = true;
          reject("Opis artikla polje je obavezno");
        }
        if (
          this.product.purchase_production_price > 999999999999.9999 ||
          this.product.purchase_production_price < 0
        ) {
          has_errors = true;
          reject("Nabavna cijena artikla nije ispravna");
        }
        if (
          this.product.vpc > 999999999999.9999 ||
          this.product.vpc < 0 ||
          this.product.vpc < this.product.purchase_production_price
        ) {
          has_errors = true;
          reject("Osnovna cijena artikla nije ispravna");
        }
        // this.product.pdv_postotak can only be 0 or 17
        if (this.product.pdv_postotak != 0 && this.product.pdv_postotak != 17) {
          has_errors = true;
          reject("PDV postotak mora biti 0 ili 17");
        }
        if (!has_errors) {
          resolve();
        }
      });
    },
    close_dialog() {
      this.$webpageEventBus.$emit(
        this.close !== null ? this.close : "close_product"
      );
    },
    setup_event_listeners() {
      this.$webpageEventBus.$on("wp_supplier_changed", (supplier) => {
        if (supplier !== null) {
          this.product.account_id = this.$store.getters.user.account_id;
          this.product.supplier_id = supplier.id;
        }
      });
      this.$webpageEventBus.$on("wp_event_jm_updated", (resp) => {
        if (resp !== null) {
          this.product.jm_id = resp.id;
        }
      });
    },
    cleanup_event_listeners() {
      this.$webpageEventBus.$off("wp_supplier_changed");
      this.$webpageEventBus.$off("wp_event_jm_updated");
    },
    get_product() {
      this.$http({
        method: "POST",
        url: "/artikli/get_product",
        data: {
          id: this.id,
          account_id: this.$store.getters.user.account_id,
        },
      }).then((resp) => {
        let r_product = resp.data.result[0];
        this.is_loading = false;
        this.product.id = r_product.id;
        this.product.naziv = r_product.naziv;
        this.product.aktivan = r_product.aktivan;
        this.product.vpc = r_product.vpc;
        this.product.opis = r_product.opis;
        this.product.sifra = r_product.sifra;
        this.product.pdv_postotak = r_product.pdv_postotak;
        this.product.article_type = r_product.article_type;
        this.product.purchase_production_price =
          r_product.purchase_production_price;
        this.product.serial_number = r_product.serial_number;
        this.product.ean_code = r_product.ean_code;
        this.product.shelf_life = r_product.shelf_life;
        this.product.supplier_id = r_product.supplier_id;
        this.product.jm_id = r_product.jm_id;
        this.product.is_price_list = r_product.is_price_list;
        this.product.is_deleted = r_product.is_deleted;
      });
    },
    save_product() {
      this.validate()
        .then(() => {
          this.is_btn_loading = true;
          this.product.account_id = this.$store.getters.user.account_id;
          this.$http({
            method: "POST",
            url: "/artikli/update",
            data: this.product,
          }).then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("show_status", {
                type: "success",
                message: "Artikal je ažuriran",
                timeout: 2000,
              });
              this.$webpageEventBus.$emit("evt_close_product");
              this.close_dialog();
              this.$webpageEventBus.$emit("reload_data");
            } else {
              this.$webpageEventBus
                .$emit("show_status", {
                  type: "error",
                  message: resp.data.message,
                  timeout: 4000,
                })
                .finally(() => {
                  this.is_btn_loading = false;
                });
            }
          });
        })
        .catch((e) => {
          this.$webpageEventBus.$emit("show_status", {
            type: "error",
            message: e,
            timeout: 4000,
          });
        });
    },
  },
};
</script>

<style scoped>
.master_grid {
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  width: 100%;
  padding: 0px 0px 0px;
}

.left_grid {
  color: white;
  display: grid;
  grid-template-rows: 1fr max-content;
  height: 100%;
}

.v-tooltip__content {
  color: black;
  opacity: 1;
}
</style>
